// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Expln_React_Row = require("@expln/utils/src/main/react-mui-components/Expln_React_Row.bs.js");
var MM_react_common = require("../ui-utils/MM_react_common.bs.js");
var Expln_React_Column = require("@expln/utils/src/main/react-mui-components/Expln_React_Column.bs.js");
var Expln_React_common = require("@expln/utils/src/main/Expln_React_common.bs.js");
var Paper = require("@mui/material/Paper").default;
var TextField = require("@mui/material/TextField").default;
var Save = require("@mui/icons-material/Save").default;
var IconButton = require("@mui/material/IconButton").default;
var HelpOutline = require("@mui/icons-material/HelpOutline").default;
var CancelOutlined = require("@mui/icons-material/CancelOutlined").default;

function makeInitialState(param) {
  return {
          newText: ""
        };
}

function setNewText(st, text) {
  return {
          newText: text
        };
}

function rndIconButton(icon, onClick, activeOpt, title, colorOpt, param) {
  var active = activeOpt !== undefined ? activeOpt : true;
  var color = colorOpt !== undefined ? Caml_option.valFromOption(colorOpt) : "primary";
  return React.createElement("span", {
              title: title
            }, React.createElement(IconButton, {
                  onClick: (function (param) {
                      Curry._1(onClick, undefined);
                    }),
                  color: color,
                  disabled: !active,
                  children: Caml_option.some(icon)
                }));
}

function MM_cmp_multiline_text(props) {
  var onHelp = props.onHelp;
  var buttonDirHor = props.buttonDirHor;
  var fullWidth = props.fullWidth;
  var width = props.width;
  var renderer = props.renderer;
  var editByAltClick = props.editByAltClick;
  var onEditCancel = props.onEditCancel;
  var onEditDone = props.onEditDone;
  var onEditRequested = props.onEditRequested;
  var editMode = props.editMode;
  var text = props.text;
  var editByAltClick$1 = editByAltClick !== undefined ? editByAltClick : false;
  var width$1 = width !== undefined ? width : 600;
  var fullWidth$1 = fullWidth !== undefined ? fullWidth : false;
  var buttonDirHor$1 = buttonDirHor !== undefined ? buttonDirHor : true;
  var match = React.useState(function () {
        return {
                newText: ""
              };
      });
  var setState = match[1];
  var state = match[0];
  React.useEffect((function () {
          if (editMode) {
            Curry._1(setState, (function (__x) {
                    return {
                            newText: text
                          };
                  }));
          }
          
        }), [editMode]);
  var actNewTextUpdated = function (newText) {
    Curry._1(setState, (function (__x) {
            return {
                    newText: newText
                  };
          }));
  };
  var actEditDone = function (param) {
    Curry._1(onEditDone, state.newText.trim());
  };
  var actEditCancel = function (param) {
    Curry._1(onEditCancel, state.newText.trim());
  };
  var rndButtons = function (param) {
    var saveBtn = rndIconButton(React.createElement(Save, {}), actEditDone, true, "Save, Enter", undefined, undefined);
    var cancelBtn = rndIconButton(React.createElement(CancelOutlined, {}), actEditCancel, undefined, "Cancel, Esc", Caml_option.some(undefined), undefined);
    var helpBtn = onHelp !== undefined ? rndIconButton(React.createElement(HelpOutline, {}), onHelp, undefined, "Help", Caml_option.some(undefined), undefined) : null;
    if (buttonDirHor$1) {
      return React.createElement(Expln_React_Row.make, {
                  children: Caml_option.some(null)
                }, saveBtn, cancelBtn, helpBtn);
    } else {
      return React.createElement(Expln_React_Column.make, {
                  children: Caml_option.some(null)
                }, saveBtn, cancelBtn, helpBtn);
    }
  };
  if (editMode) {
    var width$2;
    if (fullWidth$1) {
      var windowWidth = window.innerWidth;
      width$2 = windowWidth - 200 | 0;
    } else {
      width$2 = width$1;
    }
    var partial_arg = actEditCancel;
    var partial_arg$1 = actEditDone;
    return React.createElement(Expln_React_Row.make, {
                children: Caml_option.some(null)
              }, React.createElement(TextField, {
                    value: state.newText,
                    size: "small",
                    style: {
                      width: String(width$2) + "px"
                    },
                    multiline: true,
                    minRows: buttonDirHor$1 ? 1 : (
                        Belt_Option.isNone(onHelp) ? 3 : 5
                      ),
                    onChange: (function (param) {
                        return Expln_React_common.evt2str(actNewTextUpdated, param);
                      }),
                    onKeyDown: (function (param) {
                        return MM_react_common.kbrdHnd(undefined, partial_arg$1, partial_arg, undefined, param);
                      }),
                    autoFocus: true,
                    title: "Enter to save, Shift+Enter to start a new line, Esc to cancel"
                  }), rndButtons(undefined));
  }
  var style = text.trim() === "" ? ({
        padding: "4px"
      }) : ({
        padding: "0px"
      });
  return React.createElement(Paper, {
              onClick: editByAltClick$1 ? (function (__x) {
                    if (__x.button === 0 && __x.altKey) {
                      return Curry._1(onEditRequested, undefined);
                    }
                    
                  }) : (function (__x) {
                    if (__x.button === 0) {
                      return Curry._1(onEditRequested, undefined);
                    }
                    
                  }),
              style: style,
              variant: "outlined",
              title: editByAltClick$1 ? "Alt + <left-click> to change" : "<left-click> to change",
              children: Caml_option.some(text.trim() === "" || Belt_Option.isNone(renderer) ? React.createElement("pre", undefined, text) : Curry._1(Belt_Option.getExn(renderer), text))
            });
}

var make = MM_cmp_multiline_text;

exports.makeInitialState = makeInitialState;
exports.setNewText = setNewText;
exports.rndIconButton = rndIconButton;
exports.make = make;
/* react Not a pure module */
